export default function Navbar() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-transparent transition-colors duration-300" id="navbar">
      <div className="max-w-[1440px] mx-auto px-8 md:px-16 py-6 flex items-center justify-between">
        <div className="flex items-center gap-12">
          <span className="text-xs font-medium tracking-[0.15em] uppercase text-foreground-500">
            Engineering
          </span>
          <span className="text-xs font-medium tracking-[0.15em] uppercase text-foreground-500">
            Approach
          </span>
          <span className="text-xs font-medium tracking-[0.15em] uppercase text-foreground-500">
            Expertise
          </span>
          <span className="text-xs font-medium tracking-[0.15em] uppercase text-foreground-500">
            Values
          </span>
        </div>
        <div></div>
      </div>
    </nav>
  );
}